export type UaeTourActivity = {
  id: number;
  name: string;
  location: string;
  category: string;
  duration: string;
  img: string;
  highlights: string[];
  badge: string | null;
  badgeColor: string;
  waText: string;
  // Optional richer detail-page fields (used by /uae-tours/<slug>)
  startingPrice?: number;
  priceLabel?: string;
  description?: string;
  inclusions?: string[];
};

export const UAE_TOUR_ACTIVITIES: UaeTourActivity[] = [
  {
    id: 1,
    name: 'Desert Safari',
    location: 'Dubai & Abu Dhabi Desert',
    category: 'Safari',
    duration: '4-18 Hours',
    img: '/images/desert-safari-dune-bashing.jpg',
    highlights: ['From AED 120 per person', 'Morning, evening & overnight options', 'Dune bashing, BBQ dinner, quad biking & live shows', 'Shared & private 4x4 options'],
    badge: 'Best Seller',
    badgeColor: 'bg-sky-blue',
    waText: 'Hi Big Bird Travel, I want to book a Desert Safari. Please share availability and price.',
  },
  {
    id: 2,
    name: 'Dhow Cruise Dinner',
    location: 'Dubai Marina',
    category: 'Cruise',
    duration: '2 Hours',
    img: '/images/dhow-cruise-royal-marina-star.webp',
    highlights: [
      'From AED 60 per person (7 PM show) / AED 65 (9 PM show)',
      '2-hour cruise along Dubai Marina from Marina Walk',
      'Unlimited buffet dinner (drinks on demand)',
      '4 live entertainment shows on board',
      'Two nightly departures: 7:00 PM & 9:00 PM',
      'Glass-enclosed, air-conditioned boat with open-air deck',
    ],
    badge: 'Popular',
    badgeColor: 'bg-deep-navy',
    startingPrice: 60,
    priceLabel: 'From',
    description: 'Sail along Dubai Marina aboard the Royal Marina Star for a two-hour premium dinner cruise departing from Marina Walk. Enjoy an unlimited buffet with drinks on demand, four live entertainment shows, and the glittering Marina skyline from a glass-enclosed, air-conditioned boat with an open-air deck. Two nightly departures — 7:00 PM and 9:00 PM — make it easy to fit around your evening.',
    inclusions: [
      '2-hour Dubai Marina dinner cruise from Marina Walk',
      'Unlimited buffet — salad bar, main course and sweets',
      'Salad bar: coleslaw, mixed Arabian salad, channa & pasta salad, cucumber yogurt (raita), hummus and Arabic bread',
      'Main course: fried rice, veg & chicken biryani, chicken chilli curry, mixed veg curry, dal, aloo Manchurian, mixed BBQ (chicken & kebab), pasta, noodles, fried chicken strips and mini chicken sandwiches',
      'Sweets: fruit custard, rice pudding (kheer) and vermicelli sweet',
      'Drinks on demand',
      '4 live entertainment shows on board',
    ],
    waText: 'Hi Big Bird Travel, I want to book the Dhow Cruise Dinner (Royal Marina Star). Please share availability and price for the 7 PM or 9 PM show.',
  },
  {
    id: 3,
    name: 'Luxury Yacht Rental',
    location: 'Dubai Marina',
    category: 'Cruise',
    duration: 'From 2 Hours',
    img: '/images/luxury-yacht-dubai-marina.jpg',
    highlights: ['Private deck', 'Professional crew', 'Swimming stop', 'Soft drinks'],
    badge: 'Premium',
    badgeColor: 'bg-amber-500',
    waText: 'Hi Big Bird Travel, I am interested in Luxury Yacht Rental. Please share availability and price.',
  },
  {
    id: 4,
    name: 'Dubai City Tour',
    location: 'Dubai, UAE',
    category: 'Tours',
    duration: '4-5 Hours',
    img: '/images/dubai-city-tour-skyline.jpg',
    highlights: ['Dubai landmarks', 'Shopping areas & Jumeirah', 'Marina views', 'Modern attractions'],
    badge: null,
    badgeColor: '',
    waText: 'Hi Big Bird Travel, I want to book the Dubai City Tour. Please share availability and price.',
  },
  {
    id: 5,
    name: 'Abu Dhabi City Tour',
    location: 'Abu Dhabi, UAE',
    category: 'Tours',
    duration: '8 Hours',
    img: 'https://images.unsplash.com/photo-1512632578888-169bbbc64f33?q=80&w=600&fm=webp',
    highlights: ['Sheikh Zayed Grand Mosque', 'Corniche & Emirates Palace area', 'Cultural highlights', 'Expert guide'],
    badge: 'Top Rated',
    badgeColor: 'bg-green-500',
    waText: 'Hi Big Bird Travel, I want to book the Abu Dhabi City Tour. Please share availability and price.',
  },
  {
    id: 6,
    name: 'Burj Khalifa Visit',
    location: 'Downtown Dubai',
    category: 'Tickets',
    duration: 'Flexible',
    img: 'https://images.unsplash.com/photo-1518684079-3c830dcef090?q=80&w=600&fm=webp',
    highlights: ['At the Top - Level 124', 'Dubai Fountain view', 'Skip-the-line entry', 'Add-on options'],
    badge: null,
    badgeColor: '',
    waText: 'Hi Big Bird Travel, I want to book the Burj Khalifa visit. Please share availability and price.',
  },
];

export const UAE_TOUR_CATEGORIES = ['All', 'Safari', 'Cruise', 'Tours', 'Adventure', 'Tickets'];
